import Modal from "../Modal";
import Button from "../../Button/Button";
import "./PayoutModal.css";
import { CreateStripeConnectAccount } from "../../../services/stripeConnect.service";
import useAuthService from "../../../auth/AuthService";
import { useState } from "react";

const PayoutModal: React.FC<{
  isVisible?: boolean;
  onClick?: () => void;
  onClose: () => void;
}> = ({ isVisible, onClose }) => {
  const { getToken } = useAuthService();
  const [state, setState] = useState({
    isLoading: false,
  });

  const handleCreateStripeConnectAccount = async () => {
    setState({ isLoading: true });
    try {
      const res = await CreateStripeConnectAccount(getToken);
      if (res?.data !== null && res.error === null) {
        window.location.href = res.data.onboarding_link;
      } else {
        console.error("No URL found in response");
      }
    } catch (error) {
      console.error("Error creating Stripe connect account:", error);
      setState({ isLoading: false });
    }
  };

  const modalBody = (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      <div className="modal-body bg-modalbody mx-5 px-5 pt-0 mt-0 mb-3">
        <div className="payout-modal">
          <div className="line-20 font-inter text-center mt-3">
            <div className="font-400-15">You will be redirected to Stripe<br/>
              to securely link your bank account.
            </div>
          </div>
          <Button
            variant="primary"
            className="w-100 payout-btn mt-4"
            label={<span className="payout-text me-2">Go to Stripe</span>}
            icon={<i className="fa-solid fa-arrow-up-right-from-square"></i>}
            onClick={handleCreateStripeConnectAccount}
          />
        </div>
      </div>
    </>
  );

  return (
    <Modal
      id="PayoutModal"
      title="Set up payouts"
      body={modalBody}
      modalBackground={"modal-bg"}
      onClose={onClose}
      isVisible={isVisible}
    />
  );
};

export default PayoutModal;
